export default "skymp5-front/de4758f012a506abadf300ba210147d4.gif";